import React, {  useContext, useEffect, useState } from "react";
import AppSettings from "../../../Settings/AppSettings";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import { AppContext } from "../../../Context/AppContext";
import ProductExport from "../../../Components/GMS/Export/ProductExport";
import Label from "../../../Components/Common/components/Label";

function PdwManage(props) {

  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  let appData = useContext(AppContext);
  let industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  const [Loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [categoriesList, setCategoriesList] = useState(null);

  useEffect(() => {
    load_categories();
  }, []);

  async function load_categories() {
    setLoading({ status: "Loading", message: "Loading Categories Details" });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}category/getbyindustryid/${industryId}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        setLoading({ status: "Success", message: undefined });
        res.data.data.forEach(function (item, index) {
          item.selected = false;
        });
        await setCategoriesList(res.data.data);
      } else {
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      setLoading({
        status: "Error",
        message: "Error while Fetching categories details",
      });
    }
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div
          className="overflow-scroll container-fluid"
          style={{
            borderBottom: "1px solid #c9c9cf",
            paddingBottom: "0px",
            paddingTop: "0px",
            marginBottom: "20px",
          }}
        >
          <div style={{ float: "left" }}>
            <Label message="Export Products" fontSize={"1"} />
          </div>
        </div>
        <div className="row" />
        {( Loading.status === "Loading" &&
          <div className="ms-1">
              <div className="p-3 mb-4 col-2 skeleton"></div>
              <div className="col-11 justify-content-between ms-0 row">
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
              </div>
              <div className="col-11 justify-content-between ms-0 row">
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
              </div>
              <div className="col-11 justify-content-between ms-0 row">
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
              </div>
              <div className="col-11 justify-content-between ms-0 row">
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
              </div>
              <div className="col-11 justify-content-between ms-0 row">
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
                  <div className="p-2 col-2 skeleton"></div>
              </div>
              <div className="p-3 mt-4 col-1 skeleton"></div>
          </div>
        )}
        {Loading.status === "Success" && (
          <div>
            <div className="mt-3 tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active "
                id="download"
                role="tabpanel"
                aria-labelledby="download-tab"
              >
                {categoriesList && categoriesList.length > 0 ? (
                  <ProductExport
                    categoriesList={categoriesList}
                    setCategoriesList={setCategoriesList}
                  />
                ) : (
                  <p>No categories available to select</p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default PdwManage;
